export type Choice<First, Second> = First | Second;

export function ForceAssing(source: any, key: string, value: any) {
  source[key] = value;
}

export type TupleToUnion<T extends readonly any[]> = T[number];
